import { render, staticRenderFns } from "./ChooseAction.vue?vue&type=template&id=4a103d5c&scoped=true&"
import script from "./ChooseAction.vue?vue&type=script&lang=js&"
export * from "./ChooseAction.vue?vue&type=script&lang=js&"
import style0 from "./ChooseAction.vue?vue&type=style&index=0&id=4a103d5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a103d5c",
  null
  
)

export default component.exports